import { RolesState } from './interfaces/roles.state';
import { createReducer, on } from '@ngrx/store';
import * as RolesActions from './roles.actions';
import { getItems, updateItems } from '../../pages/policy-settings/policies/state/utils/base-list.helpers';

const initState: RolesState = {
  roles: [],
  role: null,
  filter: '',
  loading: false,
  updateLoading: false,
};

export const rolesReducers = createReducer(
  initState,
  on(RolesActions.setRolesFilter, (state, { filter }) => ({
    ...state,
    filter,
  })),
  on(RolesActions.getRoles, getItems),
  on(RolesActions.getRole, getItems),
  on(RolesActions.addRole, updateItems),
  on(RolesActions.removeRole, updateItems),
  on(RolesActions.updateRole, updateItems),
  on(RolesActions.setRoles, (state, { roles }) => ({
    ...state,
    roles,
    loading: false,
  })),
  on(RolesActions.getRolesSuccess, (state, { roles }) => ({
    ...state,
    roles,
    loading: false,
  })),
  on(RolesActions.getRoleSuccess, (state, { role }) => ({
    ...state,
    role,
    loading: false,
  })),
  on(RolesActions.addRoleSuccess, (state, { role }) => ({
    ...state,
    roles: [...state.roles, role],
    updateLoading: false,
  })),
  on(RolesActions.addRoleFailed, (state) => ({
      ...state,
      updateLoading: false,
    })),
  on(RolesActions.removeRoleSuccess, (state, { roleId }) => ({
    ...state,
    roles: state.roles.filter(_role => _role.id !== roleId),
    updateLoading: false,
  })),
  on(RolesActions.updateRoleSuccess, (state, { role }) => ({
    ...state,
    roles: state.roles.map(_role => _role.id === role.id ? role : _role),
    updateLoading: false,
  })),
);
